import { AppFeature, DataRule } from '@/types';
import { APP_DATA_RULES, APP_FEATURES, Core } from '../Core';

class AppFeatures extends Core {
  getAppFeatures = async () => this.get<AppFeature[]>(APP_FEATURES());

  getDataRules = async () => this.get<DataRule[]>(APP_DATA_RULES());
}

export const appFeatures = new AppFeatures();
